import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {}

const EditIcon: React.FC<Props> = () => {
  return (
    <SVGIcon width="21" height="20" viewBox="0 0 21 20" fill="none">
      <path
        d="M15.1078 2.0874C14.36 2.0874 13.6123 2.37089 13.0456 2.93783L3.8228 12.1598C3.64781 12.3348 3.51965 12.5524 3.45171 12.7913L2.21554 17.12C2.18506 17.2271 2.18374 17.3404 2.21173 17.4482C2.23972 17.556 2.296 17.6543 2.37474 17.7331C2.45349 17.8118 2.55184 17.8681 2.65963 17.8961C2.76742 17.9241 2.88073 17.9227 2.98784 17.8923L7.31727 16.6561L7.31808 16.6553C7.55538 16.5871 7.77247 16.4605 7.94797 16.285L17.17 7.06217C18.3038 5.92837 18.3038 4.07163 17.17 2.93783C16.6033 2.37089 15.8556 2.0874 15.1078 2.0874ZM15.1078 3.33008C15.5331 3.33008 15.9579 3.49397 16.2854 3.82161H16.2862C16.9424 4.47781 16.9424 5.52219 16.2862 6.17839L15.4781 6.98649L13.1213 4.62972L13.9294 3.82161C14.2569 3.49397 14.6825 3.33008 15.1078 3.33008ZM12.2375 5.51351L14.5943 7.87028L7.06336 15.4012C7.03893 15.4255 7.00799 15.4441 6.97303 15.4541L3.72596 16.3818L4.65369 13.134V13.1331C4.66325 13.0995 4.68075 13.0695 4.70659 13.0436L12.2375 5.51351Z"
        fill="#187A90"
      />
    </SVGIcon>
  );
};

export default EditIcon;
